import { PaletteMode } from '@mui/material';
import base from './base';

export default {
  ...base,
  mode: 'light' as PaletteMode,
  primary: {
    contrastText: '#FFF',
    main: '#3861FB',
    A100: '#3861FB',
    A80: '#587DF5',
    A60: '#9CB0FD',
    A40: '#D1DCFF',
    A20: '#EBF1FF',
    A10: '#F0F6FF'
  },
  secondary: {
    contrastText: '#222531',
    main: '#EFF2F5',
    A100: '#EFF2F5',
    A80: '#F7F9FA',
    A60: '#FAFBFC'
  },
  success: {
    contrastText: '#FFF',
    main: '#16C784',
    A100: '#16C784',
    A80: '#2CDB99',
    A60: '#93EDCB',
    A40: '#B8F2DD',
    A20: '#E3FCF3'
  },
  warning: {
    contrastText: '#FFF',
    main: '#EBBC2E',
    A100: '#EBBC2E',
    A80: '#FCE188',
    A60: '#FCE7A4',
    A40: '#FCF3D6',
    A20: '#FFF9E5'
  },
  error: {
    contrastText: '#FFF',
    main: '#EA3943',
    A100: '#EA3943',
    A80: '#ED5159',
    A60: '#FF8F95',
    A40: '#FFC2C6',
    A20: '#FFEBEC'
  },
  info: {
    contrastText: '#FFF',
    main: '#717BEB',
    A100: '#717BEB',
    A80: '#848EF5',
    A60: '#9CA4FF',
    A40: '#D9DCFF',
    A20: '#EDEFFF'
  },
  base: {
    main: '#222531',
    A100: '#222531',
    A80: '#333640',
    A60: '#3A3A3D',
    A40: '#666666',
    A20: '#E4E7EB',
    A0: '#FFFFFF'
  },
  grayBackground: {
    base: '#F7F7F7',
    A0: '#F7F7F7',
    main: '#808A9D',
    A100: '#808A9D',
    A80: '#A6B0C3',
    A60: '#A6B1C2',
    A40: '#CFD6E4',
    A20: '#EFF2F5',
    A10: '#F8FAFD'
  },
  textColor: {
    main: '#222531',
    A80: '#222531',
    A70: '#666666',
    A60: '#58667E',
    A50: '#808A9D',
    A40: '#A6B0C3',
    A30: '#CFD6E4',
    A20: '#EFF2F5',
    A10: '#F8FAFD',
    A0: '#FFFFFF'
  }
};
